<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
      </app-form-save-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            Flowbird Configuration
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" placeholder="Required" maxlength="100">
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <textarea formControlName="Description" class="input" placeholder="Optional description" maxlength="500"></textarea>
                <app-validator [For]="Form.get('Description')"></app-validator>
              </div>
            </app-field>
            <app-field Label="API URL">
              <div class="control">
                <input formControlName="Url" class="input" placeholder="Required" maxlength="200">
                <app-validator [For]="Form.get('Url')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Username">
              <div class="control">
                <input formControlName="Username" class="input" placeholder="Required" maxlength="100">
                <app-validator [For]="Form.get('Username')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Password">
              <div class="control">
                <input formControlName="Password" type="password" class="input" placeholder="Leave blank to keep existing" maxlength="100">
                <app-validator [For]="Form.get('Password')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Import Schedule Minutes">
              <div class="control">
                <input formControlName="ImportScheduleMinutes" type="number" class="input" placeholder="Required" min="1">
                <app-validator [For]="Form.get('ImportScheduleMinutes')"></app-validator>
              </div>
            </app-field>
          </div>
        </article>
        <article class="panel">
          <p class="panel-heading">
            Terminal Mappings
            <button type="button" class="button is-small is-primary is-pulled-right" (click)="AddTerminalMapping()">
              <span class="icon"><i class="fa fa-plus"></i></span>
              <span>Add Mapping</span>
            </button>
          </p>
          @if (TerminalMappingsArray.length === 0) {
            <div class="panel-block" style="display: block;">
              <p class="has-text-grey-light">No terminal mappings configured. Click "Add Mapping" to create one.</p>
            </div>
          }
          @for (mapping of TerminalMappingsArray.controls; track mapping; let i = $index) {
            <div class="panel-block terminal-mapping" style="display: block;" [formGroup]="$any(mapping)">
              <div style="width:100%;" class="columns is-vcentered">
                <div class="column is-5">
                  <app-field Label="Terminal ID">
                    <div class="control">
                      <input formControlName="TerminalId" class="input" placeholder="Flowbird Terminal GUID">
                      <app-validator [For]="mapping.get('TerminalId')"></app-validator>
                    </div>
                  </app-field>
                </div>
                <div class="column is-5">
                  <app-field Label="Parking Lot External ID">
                    <div class="control">
                      <input formControlName="ParkingLotExternalId" class="input" placeholder="FrogOne Parking Lot External ID" maxlength="100">
                      <app-validator [For]="mapping.get('ParkingLotExternalId')"></app-validator>
                    </div>
                  </app-field>
                </div>
                <div class="column is-2 has-text-right">
                  <button type="button" class="button is-danger is-small" (click)="RemoveTerminalMapping(i)" title="Remove mapping">
                    <span class="icon"><i class="fa fa-trash"></i></span>
                  </button>
                </div>
              </div>
            </div>
          }
        </article>
      </div>
    </div>
  </div>
}

